import type { Tour, TourId } from '../tour-state.js';
import account from './account.js';
import onboarding from './onboarding.js';
import welcome from './welcome.js';
import workflows from './workflows.js';

// Every tour by id, as ns-workflows/jobs/index.ts registers jobs. Each target is a data-tour-id in
// the app; the e2e specs check they all still resolve.
const tours: Record<TourId, Tour> = { onboarding, welcome, workflows, account };

export default tours;
